$(function () {
    var searchOpen = false;

    function openSearch() {
        if (
            searchOpen === true
            || window.location.pathname.indexOf('/ng/') !== -1
        ) {
            return;
        }

        searchOpen = true;
        $('#search-modal').dialog({ modal: true, dialogClass: 'visible-overflow' }); //no-titlebar 
        searchOpen = false;
    }

    // open search when user presses [ctrl]+.
    $(window).on('keydown', function (e) {
        if (searchOpen === false && e.ctrlKey === true && e.keyCode === 190) {
            openSearch();
        }
    });

    $('#navbar .fa-search').on('click', function (e) {
        openSearch();
    });

    if (typeof xSearch === 'function') {
        $('#search-modal input').typeahead({
            minLength: 1,
            highlight: true
        },
        {
            display: "v",
            name: 'x',
            source: xSearch,
            templates: {
                suggestion: $.templates('<div>{{>text}}</div>')
            }
        });
    }

    $('#search-modal input').on('typeahead:select', function (ev, suggestion) {
        if (suggestion.value.t === "loan") {
            window.location = ResolveUrl("~/SiteAdmin/SearchLoans.aspx?q=") + encodeURIComponent(suggestion.value.v.trim());
        }
        else if (suggestion.value.t === "branch") {
            window.location = ResolveUrl("~/Directory/Branches.aspx?q=") + encodeURIComponent(suggestion.value.v.trim());
        }
        else if (suggestion.value.t === "employee") {
            window.location = ResolveUrl("~/Directory/Default.aspx?q=") + encodeURIComponent(suggestion.value.v.trim());
        }
    });

});
